<template>
    <layout-interno>
        <template #topo>
            <topo/>
        </template>
        <slot/>
    </layout-interno>
</template>
<script>
import LayoutInterno from '@/shared/layouts/adminlte/components/Interno'
import Topo from './Topo'
export default {
    components: {
        LayoutInterno,
        Topo
    }
}
</script>
